import { GeneralLocaleTypes } from '../locales.types'

const generalLocaleEs: GeneralLocaleTypes = {
  username: 'Nombre de usuario',
  imageAlt: {},
  status: {
    error: {
      somethingWentWrong: 'Algo salió mal',
      sessionError:
        'Imposible verificar sesión, por favor inténtalo de nuevo más tarde...'
    }
  },
  actions: {
    back: 'Atrás',
    cancel: 'Cancelar',
    moveOn: 'Continuar',
    edit: 'Editar',
    delete: 'Eliminar',
    remove: 'Remover',
    next: 'Siguiente',
    save: 'Guardar {{ addOn }}',
    update: 'Actualizar {{ addOn }}',
    select: 'Seleccionar',
    confirm: 'Confirmar',
    revoke: 'Revocar',
    close: 'Cerrar'
  },
  or: 'o'
}
export default generalLocaleEs
